import { c as _c } from "react/compiler-runtime";
import { ComponentSharedBackground, Maybe } from "@lib/generated/graphql";
import { slugify } from "@lib/routing";
import clsx from "clsx";
import { PropsWithChildren, forwardRef } from "react";
import Background from "../Background";
export interface SectionData {
  background?: Maybe<ComponentSharedBackground>;
  navigationLink?: string;
}
export interface SectionProps<T extends object | SectionData> {
  index?: number;
  section: T;
  className?: string;
  padding?: boolean;
  id?: string;
}
export const SECTION_PADDING = "px-s m:px-3xl";
const getSectionId = (section: SectionData) => {
  const link = section.navigationLink;
  return link && slugify(link);
};
const Section = forwardRef<HTMLElement, PropsWithChildren<SectionProps<object | SectionData>>>(function Section(t0, ref) {
  const $ = _c(13);
  const {
    id,
    index,
    section,
    children,
    className,
    padding: t1
  } = t0;
  const padding = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== id || $[1] !== section) {
    t2 = id || getSectionId(section);
    $[0] = id;
    $[1] = section;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const idAttr = t2;
  const t3 = section as SectionData;
  const t4 = t3.background;
  const t5 = index === 0;
  let t6;
  if ($[3] !== className || $[4] !== padding || $[5] !== t5) {
    t6 = clsx("rounded-m scroll-m-5xl", className, {
      "!mt-2s": t5,
      [SECTION_PADDING]: padding
    });
    $[3] = className;
    $[4] = padding;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== children || $[8] !== idAttr || $[9] !== ref || $[10] !== t3.background || $[11] !== t6) {
    t7 = <Background ref={ref} id={idAttr} background={t4} className={t6}>{children}</Background>;
    $[7] = children;
    $[8] = idAttr;
    $[9] = ref;
    $[10] = t3.background;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
});
export default Section;